<template>
  <div class="push-setting page-background-new">
    <div class="push-setting-content">
      <van-field
        label="推送日期:"
        v-model="pushDate"
        placeholder="请选择开始执行日期"
        readonly
        @click="showDate()"
      >
      </van-field>
      <van-field
        label="推送频率:"
        v-model="frequency"
        placeholder="请选择推送频率"
        readonly
        @click="showfrequency()"
      >
      </van-field>
      <div class="push-setting-content-detail">
        <div class="push-setting-content-detail-title">项目名称:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="title"
          rows="5"
          placeholder="请输入名称"
        />
        <div class="push-setting-content-detail-title">申办方:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="sponsor"
          rows="5"
          placeholder="请输入申办方"
        />
        <div class="push-setting-content-detail-title">操作内容:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="operationalContext"
          rows="2"
          autosize="{ maxHeight: 200, minHeight: 200 }"
          type="textarea"
          placeholder="请输入操作内容"
        />
        <div class="push-setting-content-detail-title">操作记录:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="operationalLog"
          rows="2"
          autosize="{ maxHeight: 200, minHeight: 200 }"
          type="textarea"
          placeholder="请输入操作记录"
        />
        <div class="push-setting-content-detail-title">补充说明:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="declare"
          rows="2"
          autosize="{ maxHeight: 200, minHeight: 200 }"
          type="textarea"
          placeholder="请输入补充说明"
        />
        <div class="push-setting-content-detail-title">推送内容:</div>
        <van-field
          style="margin-top:1rem;padding:0 .5rem;border:1px solid #efefef;border-radius:5px"
          v-model="content"
          rows="5"
          autosize="{ maxHeight: 500, minHeight: 500 }"
          type="textarea"
          placeholder="请输入内容"
        />
        <div class="push-setting-content-detail-prompt">
          <div style="margin-top:1rem;font-weight:500">温馨提示</div>
          <div style="margin-top:.5rem;font-size:.67rem">
            点击下方【确认设置】按钮，以上所有信息必填且将按照设置的日期和频率开始定时推送;
            如需立即开始推送，“推送日期”与“推送频率"可不做填写只需填写推送内容后点击【立即推送】按钮
          </div>
        </div>
      </div>
    </div>
    <div class="push-setting-bottom">
      <div
        style="margin:0 .5rem 0 1rem;background-color:white;"
        @click="pushClick()"
      >
        立即推送
      </div>
      <div
        style="margin:0 1rem 0 .5rem;color:white;background-color:#09f"
        @click="settingClick()"
      >
        确认设置
      </div>
    </div>
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        v-model="startDate"
        @cancel="showStart = false"
        @confirm="confirmPicker"
        type="date"
        title="选择开始时间"
      />
    </van-popup>
    <van-popup v-model="showFrequencyPicker" position="bottom">
      <van-picker
        :columns="frequencyList"
        @confirm="frequencyConfirm"
        @cancel="showFrequencyPicker = false"
        show-toolbar
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      showStart: false,
      startDate: new Date(),
      pushDate: "",
      frequencyList: ["仅一次", "每天一次", "每周一次", "每月一次"],
      showFrequencyPicker: false,
      frequency: "",
      pushid: "",
      pushtype: "",
      title: "",
      sponsor: "",
      operationalContext: "",
      operationalLog: "",
      declare: ""
    };
  },

  created() {
    this.pushid = this.$route.query.id;
    if (this.pushid) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$http
        .post(this.$api.PUSH_GET_INFO, {
          qAccesstoken: localStorage.getItem("qAccesstoken"),
          id: this.pushid
        })
        .then(res => {
          this.content = res.context;
          this.pushDate = res.pushDate;
          this.pushtype = res.type;
          this.title = res.title;
          this.sponsor = res.sponsor;
          this.operationalContext = res.operationalContext;
          this.operationalLog = res.operationalLog;
          this.declare = res.declare;
          switch (this.pushtype) {
            case "0":
              this.frequency = "仅一次";
              break;
            case "1":
              this.frequency = "每天一次";
              break;
            case "2":
              this.frequency = "每周一次";
              break;
            case "3":
              this.frequency = "每月一次";
              break;
            default:
              break;
          }
        });
    },
    showDate() {
      this.showStart = !this.showStart;
    },
    showfrequency() {
      this.showFrequencyPicker = !this.showFrequencyPicker;
    },
    confirmPicker(selStartDate) {
      this.pushDate = this.$moment(selStartDate).format("YYYY-MM-DD");
      this.showStart = !this.showStart;
    },
    frequencyConfirm(value, index) {
      console.log(value, index);
      this.frequency = value;
      this.pushtype = index;
      this.showFrequencyPicker = !this.showFrequencyPicker;
    },
    pushClick() {
      this.$phdialog
        .confirm({
          message: "确认立即推送？",
          confirmButtonText: "确认",
          cancelButtonText: "取消"
        })
        .then(() => {
          this.push();
        });
    },
    push() {
      if (!this.pushDate) {
        alert("请设置执行日期！");
        return;
      }
      if (!this.frequency) {
        alert("请设置推送频率！");
        return;
      }
      if (!this.title) {
        alert("请填写项目名称！");
        return;
      }
      if (!this.sponsor) {
        alert("请填写申办方！");
        return;
      }
      if (!this.operationalContext) {
        alert("请填写操作内容！");
        return;
      }
      if (!this.operationalLog) {
        alert("请填写操作记录！");
        return;
      }
      if (!this.declare) {
        alert("请填写补充说明！");
        return;
      }
      if (!this.content) {
        alert("请填写推送内容！");
        return;
      }
      this.$http
        .post(this.$api.PUSH_PUSH, {
          qAccesstoken: localStorage.getItem("qAccesstoken"),
          pushDate: this.pushDate,
          type: this.pushtype,
          context: this.content,
          title: this.title,
          sponsor: this.sponsor,
          operationalContext: this.operationalContext,
          operationalLog: this.operationalLog,
          declare: this.declare
        })
        .then(res => {
          alert("推送成功");
          this.$router.go(-1);
        });
    },
    settingClick() {
      if (!this.pushDate) {
        alert("请设置执行日期！");
        return;
      }
      if (!this.frequency) {
        alert("请设置推送频率！");
        return;
      }
      if (!this.title) {
        alert("请填写项目名称！");
        return;
      }
      if (!this.sponsor) {
        alert("请填写申办方！");
        return;
      }
      if (!this.operationalContext) {
        alert("请填写操作内容！");
        return;
      }
      if (!this.operationalLog) {
        alert("请填写操作记录！");
        return;
      }
      if (!this.declare) {
        alert("请填写补充说明！");
        return;
      }
      if (!this.content) {
        alert("请填写推送内容！");
        return;
      }

      this.$http
        .post(this.$api.PUSH_ADD_SET, {
          id: this.pushid ? this.pushid : "",
          qAccesstoken: localStorage.getItem("qAccesstoken"),
          pushDate: this.pushDate,
          type: this.pushtype,
          context: this.content,
          title: this.title,
          sponsor: this.sponsor,
          operationalContext: this.operationalContext,
          operationalLog: this.operationalLog,
          declare: this.declare
        })
        .then(res => {
          alert("设置成功");
          this.$router.go(-1);
        });
    }
  }
};
</script>

<style lang="less">
.push-setting {
  width: 100%;
  height: 100%;
  overflow: scroll;
  &-bottom {
    display: flex;
    justify-content: space-between;
    line-height: 2.8rem;
    > div {
      width: 50%;
      font-weight: 500;
      text-align: center;
      border: 1px solid #efefef;
      border-radius: 1.5rem;
    }
  }
  &-content {
    margin: 1rem;
    padding: 0 1rem 2rem 1rem;
    background-color: white;
    border-radius: 0.67rem;
    &-detail {
      .van-field__control {
        line-height: 2.33rem;
        text-align: left !important;
      }
      &-title {
        margin-top: 1rem;
        color: #666;
      }
      &-prompt {
        color: #fe5546;
      }
    }
    .van-cell {
      padding: 0;
      line-height: 3.33rem;
      border-bottom: 1px solid #efefef;
    }
    .van-cell::after {
      border-bottom: 0 solid #efefef;
    }
    .van-field__control {
      text-align: right;
    }
  }
}
</style>
